module.exports = __webpack_public_path__ + "img/fall-4@2x.cfc0d2e3.png";